<template>
  <div class="billing-summary-container">
    <div>
      <v-layout align-center>
        <v-spacer />
        <div class="font-weight-bold my-2">
          {{ billingCycle }}
        </div>
      </v-layout>
    </div>
    <div class="billing-stats-container">
      <!--Collect-->
      <div class="billing-item">
        <v-layout align-center class="title font-weight-bold">
          <div>Collect</div>
          <v-spacer />
          {{ collectUsage }}
        </v-layout>
        <v-progress-linear
          v-model="collect"
          color="primary"
          height="15"
        ></v-progress-linear>
        <div class="d-flex justify-content-start">
          <v-expansion-panel
            class="expansion-panel"
            expand
            v-model="collectOpen"
          >
            <v-expansion-panel-content v-for="(item, i) in 1" :key="i">
              <template v-slot:actions>
                <v-icon color="primary">info</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  What is considered a credit usage in Collect?
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <div v-html="collectInfo" />
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>

      <!--Deliver-->
      <div class="billing-item">
        <v-layout align-center class="title font-weight-bold">
          <div>Deliver</div>
          <v-spacer />
          {{ deliverUsage }}
        </v-layout>
        <v-progress-linear
          v-model="deliver"
          color="primary"
          height="15"
        ></v-progress-linear>
        <div class="d-flex justify-content-start">
          <v-expansion-panel
            class="expansion-panel"
            expand
            v-model="deliverOpen"
          >
            <v-expansion-panel-content v-for="(item, i) in 1" :key="i">
              <template v-slot:actions>
                <v-icon color="primary">info</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  What is considered a credit usage in Deliver?
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <p>
                    {{ deliverInfo }}
                  </p>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>

      <!--Connect-->
      <div class="billing-item">
        <v-layout align-center class="title font-weight-bold">
          <div>Connect</div>
          <v-spacer />
          {{ connectUsage }}
        </v-layout>
        <v-progress-linear
          v-model="connect"
          color="primary"
          height="15"
        ></v-progress-linear>
        <div class="d-flex justify-content-start">
          <v-expansion-panel
            class="expansion-panel"
            expand
            v-model="connectOpen"
          >
            <v-expansion-panel-content v-for="(item, i) in 1" :key="i">
              <template v-slot:actions>
                <v-icon color="primary">info</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  What is considered a credit usage in Connect?
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <p>
                    {{ connectInfo }}
                  </p>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerBillingDashboard',
  components: {},
  props: {
    credits: {
      required: true,
      type: Object,
    },
    selectedYear: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      collect: 0,
      deliver: 0,
      connect: 0,
      collectOpen: 1,
      deliverOpen: 1,
      connectOpen: 1,
      openPanels: [],

      collectInfo:
        'A Collect Credit is charged when a client interacts with an entity during the billing cycle through any of the following actions:<br>' +
        '• Client signs an engagement letter<br>' +
        '• Client answers a question in a questionnaire<br>' +
        '• Firm User or Client uploads a document in a questionnaire<br>' +
        '• Firm User uses the BUP processor',
      deliverInfo:
        'A Deliver Credit is charged when a tax return is sent to client during the billing cycle.',
      connectInfo:
        'A Connect Credit is charged when a firm user exports tax form data into the tax software during the billing cycle.',
    };
  },
  computed: {
    billingCycle() {
      return `Billing Cycle: November 1, ${
        this.selectedYear
      } - October 31, ${this.selectedYear + 1}`;
    },
    collectUsage() {
      return (
        this.credits.collect.credits_used.length +
        '/' +
        (this.credits.collect.credits_purchased ||
          this.credits.collect.credits_used.length)
      );
    },
    deliverUsage() {
      return (
        this.credits.deliver.credits_used.length +
        '/' +
        (this.credits.deliver.credits_purchased ||
          this.credits.deliver.credits_used.length)
      );
    },
    connectUsage() {
      return (
        this.credits.connect.credits_used.length +
        '/' +
        (this.credits.connect.credits_purchased ||
          this.credits.connect.credits_used.length)
      );
    },
  },
  methods: {
    setOpen(item) {
      switch (item) {
        case 1:
          this.collectOpen = 0;
          break;
        case 2:
          this.deliverOpen = 0;
          break;
        case 3:
          this.connectOpen = 0;
          break;
      }
    },
    setClose(item) {
      switch (item) {
        case 1:
          this.collectOpen = 1;
          break;
        case 2:
          this.deliverOpen = 1;
          break;
        case 3:
          this.connectOpen = 1;
          break;
      }
    },
  },
  watch: {
    credits: {
      handler(value) {
        if (value) {
          this.collect =
            (value.collect.credits_used.length /
              (value.collect.credits_purchased ||
                value.collect.credits_used.length)) *
            100;
          this.deliver =
            (value.deliver.credits_used.length /
              (value.deliver.credits_purchased ||
                value.deliver.credits_used.length)) *
            100;
          this.connect =
            (value.connect.credits_used.length /
              (value.connect.credits_purchased ||
                value.connect.credits_used.length)) *
            100;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.billing-summary-container {
  margin: 0 2% 0 2%;
}
.billing-summary-subtitle {
  margin: 0 0 2% 0;
}
.billing-stats-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.billing-item {
  width: 50%;
  margin-bottom: 2%;
}
.expansion-panel {
  width: 100%;
  border: none;
  box-shadow: none;
}
</style>
